export const severity = ['high', 'medium', 'low'];
